var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgConsumo = function SvgConsumo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5259 4.40459C26.3074 3.41607 25.5709 2.00004 24.2719 2.00004H14.1977C13.9249 1.99805 13.6562 2.06627 13.4174 2.19815C13.1786 2.33002 12.9778 2.52112 12.8342 2.75306L5.21104 15.4373C4.60952 16.4363 5.36554 17.6828 6.57306 17.6828H11.7167L6.87157 29.7806C6.17105 31.3106 8.06409 32.7101 9.33612 31.6031L29 12.9968H18.7263L25.5259 4.40459V4.40459Z",
    stroke: "#002445",
    strokeWidth: 3.00006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConsumo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/consumo.5d39e65f.svg";
export { ForwardRef as ReactComponent };